<div container classes="container--1096">
  <div class="patients__header d-flex justify-content-between mb-3">
    <h2 class="mb-0">How to explain it to your patients?</h2>
    <button
      class="expand-btn d-flex align-items-center justify-content-between"
      [class.expanded]="isAllAccordionsExpanded"
      (click)="expandCollapseAllAccordions()"
    >
      <p class="h3 mb-0">
        {{ !isAllAccordionsExpanded ? "Expand all" : "Collapse all" }}
      </p>
    </button>
  </div>
  <div
    class="patients__accordion position-relative z-0 d-flex flex-column gap-3"
    ngbAccordion
    #accordions="ngbAccordion"
  >
    <!-- #1 -->
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <h3 class="mb-0">
            I eat well and exercise – why do I still need to screen?
          </h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p class="mb-0">
              Unlike type 2 diabetes, type 1 diabetes (T1D) is an autoimmune
              disease. It’s not caused by diet or lifestyle and anyone can
              develop T1D, no matter their age, family history, or lifestyle
              choices.
            </p>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- #2 -->
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <h3 class="mb-0">Doesn’t type 1 diabetes only affect children?</h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p class="mb-0">
              Some people think of type 1 diabetes as a children’s disease—more
              likely to affect kids. But over half the people who are newly
              diagnosed with type 1 diabetes get diagnosed as adults. That means
              that you or a loved one could still be at risk for T1D—at any age.
            </p>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- #3 -->
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <h3 class="mb-0">
            What are the potential benefits of T1D screening?
          </h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p>
              Many. Whether a person screens or not, if they have autoimmune
              type 1 diabetes, it will progress and get worse as time goes on.
              Eventually, life-threatening complications can happen, often
              seemingly out of nowhere. In fact as many as ~60% of people have
              no idea they have T1D until they experience a life-threatening
              event that requires hospitalization at diagnosis.<sup>8</sup>
            </p>
            <p>
              Screening can identify the risk of autoimmune type 1 diabetes
              before symptoms appear and knowing your results can help you:
            </p>
            <ul class="mb-0">
              <li>
                Understand your options and discuss next steps with treatment,
                as necessary
              </li>
              <li>
                Learn the symptoms of type 1 before they appear and lower the
                risks of possible life-threatening complications at diagnosis
              </li>
              <li>
                Make a plan with your healthcare team to monitor your blood
                sugar levels and disease progression
              </li>
            </ul>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- #3 -->
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <h3 class="mb-0">
            I have a family member with type 1 diabetes – am I more at risk?
          </h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p class="mb-0">
              If just 1 person in your family has T1D, you’re up to 15x more
              likely to develop it too<sup>9</sup>. Additionally, the risk of
              developing T1D can be 2-3 times higher if you have certain
              autoimmune diseases, such as Hashimoto’s, Graves’, or celiac
              disease<sup>10</sup>. That’s why it’s important to screen, so you
              can learn the results and take action.
            </p>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- #4 -->
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <h3 class="mb-0">
            I talked to another provider who said screening isn’t necessary. 
          </h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p class="mb-0">
              Your doctor’s guidance and expertise should always be taken
              seriously. If you feel like you or a loved one could benefit from
              early screening you can also consider getting a second opinion
              from a different healthcare professional, like an
              endocrinologist. 
            </p>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- #5 -->
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <h3 class="mb-0">Aren’t my children too young to screen?</h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p class="mb-0">
              Screening is available for children aged 1 and up. Studies have
              shown that repeat testing before the age of 15 greatly increases
              the likelihood of identifying T1D before onset of symptoms.<sup
                >11</sup
              >
            </p>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- #6 -->
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <h3 class="mb-0">No one in my family has type 1 diabetes</h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p class="mb-0">
              Anyone can develop autoimmune type 1 diabetes (T1D). In fact about
              90% of people diagnosed have no family history of T1D.<sup
                >12</sup
              >
            </p>
          </ng-template>
        </div>
      </div>
    </div>

    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <h3 class="mb-0">
            Isn’t screening expensive? Is it covered by my insurance?
          </h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p class="mb-3">
              Each screening option has a different cost. For example,
              <a
                href="https://type1testing.enablebiosciences.com/"
                target="_blank"
                rel="noopener"
                >Enable Biosciences</a
              >
              offers an at-home test you can get from a doctor.
              <a
                href="https://www.trialnet.org/participate"
                target="_blank"
                rel="noopener"
                >TrialNet</a
              >&nbsp;offers free screening to those who have a relative with
              type 1 diabetes. The cost of screening at a lab varies depending
              on your insurance coverage—but is potentially low cost or even $0
              out-of-pocket.
            </p>
            <p class="mb-0">
              This is not an exhaustive list of available screening options. The
              appropriateness of any AAb screening test and the validity of the
              test results are up to the requesting physician to determine.
            </p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
